import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    // state、mutations、actions等配置项
    state: {
        type: '789'
    },
    mutations: {
        changeType(state, type) {
            state.type = type
        }
    }
})

export default store